import React from 'react'

import config from '../config.js'

import { Link, NavLink } from 'react-router-dom'

class AppMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      active: false
    }
  }

  toggleMenu = () => {
    this.setState({ active: !this.state.active })
  }

  closeMenu = () => {
    this.setState({ active: false })
  }

  logoutHandler = e => {
    e.preventDefault()
    this.props.logout()
  }

  render() {
    return (
      <nav className="app-menu">
        <span
          className={
            (this.state.active ? 'active ' : '') +
            'app-menu__toggle material-icons md-36'
          }
          onClick={() => {
            this.toggleMenu()
          }}
        >
          menu
        </span>
        <ul className={this.state.active ? 'active' : ''}>

          <li>
            <NavLink
              to={config.baseUrl + '/' + this.props.userName + '/cookbooks'}
              activeClassName="active"
              onClick={() => {
                this.closeMenu()
              }}
            >
              My Cookbook Library
            </NavLink>
          </li>

          <li>
            <NavLink
              to={config.baseUrl + '/' + this.props.userName + '/friends'}
              activeClassName="active"
              onClick={() => {
                this.closeMenu()
              }}
            >
              My Friends
            </NavLink>
          </li>

          <li>
            <Link
              to={
                config.baseUrl + '/' + this.props.userName + '/friends/messages'
              }
              onClick={() => {
                this.closeMenu()
              }}
            >
              Messages
            </Link>
          </li>

          <li className="app-menu__link--logout">
            <a
              className="link-function"
              onClick={e => {
                this.logoutHandler(e)
              }}
            >
              Log Out
            </a>
          </li>

          <li>
            <NavLink
                to={config.baseUrl + '/' + this.props.userName + '/settings'}
                activeClassName="active"
                onClick={() => {
                  this.closeMenu()
                }}
            >
              Settings
            </NavLink>
          </li>

        </ul>
      </nav>
    )
  }
}

export default AppMenu



// WEBPACK FOOTER //
// ./src/Components/AppMenu.js